import { hasChildren$ } from '@op/services'
import { createResolverRedirect } from '../common'
import { resolveSerialRootAuth } from './resolveSerialRootAuth'
import { usersResolver } from './usersResolver'

export const resolveSerialHasChildren = /*@__PURE__*/ resolveSerialRootAuth.bind(
	null,
	usersResolver,
	(store) => {
		const onOnboardingPath = location.pathname.startsWith('/onboarding')

		if (!hasChildren$(store.getState()) && !onOnboardingPath) {
			throw createResolverRedirect('/connect')
		}
	},
)
